<header>
	<h1>Отмена запроса</h1>
	<app-svg assetsPath="close" (click)="close$.next()"></app-svg>
</header>
<section>
	<span>Вы действительно хотите отменить запрос?</span>
</section>
<footer>
	<button class="secondary" (click)="close$.next(false)">Нет</button>
	<button class="primary" (click)="cancelRefund()">Да</button>
</footer>
